module.exports = __webpack_public_path__ + "img/image-about-us-01-academy-template.7bf0c810.jpg";